<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4168 10.5415V13.6248C15.4168 16.2248 12.9918 18.3332 10.0002 18.3332C7.0085 18.3332 4.5835 16.2248 4.5835 13.6248V10.5415C4.5835 13.1415 7.0085 14.9998 10.0002 14.9998C12.9918 14.9998 15.4168 13.1415 15.4168 10.5415Z"
      stroke="url(#paint0_linear_5249_2338)"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.4168 6.37508C15.4168 7.13342 15.2085 7.83341 14.8418 8.43341C13.9502 9.90008 12.1168 10.8334 10.0002 10.8334C7.8835 10.8334 6.05016 9.90008 5.1585 8.43341C4.79183 7.83341 4.5835 7.13342 4.5835 6.37508C4.5835 5.07508 5.19182 3.90008 6.16682 3.05008C7.15016 2.19175 8.50016 1.66675 10.0002 1.66675C11.5002 1.66675 12.8502 2.19175 13.8335 3.04175C14.8085 3.90008 15.4168 5.07508 15.4168 6.37508Z"
      stroke="url(#paint1_linear_5249_2338)"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.4168 6.37508V10.5417C15.4168 13.1417 12.9918 15.0001 10.0002 15.0001C7.0085 15.0001 4.5835 13.1417 4.5835 10.5417V6.37508C4.5835 3.77508 7.0085 1.66675 10.0002 1.66675C11.5002 1.66675 12.8502 2.19175 13.8335 3.04175C14.8085 3.90008 15.4168 5.07508 15.4168 6.37508Z"
      stroke="url(#paint2_linear_5249_2338)"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5249_2338"
        x1="2.85916"
        y1="3.99434"
        x2="20.1993"
        y2="8.36172"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5249_2338"
        x1="2.85916"
        y1="-6.03579"
        x2="20.4912"
        y2="-2.26104"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5249_2338"
        x1="2.85916"
        y1="-9.53695"
        x2="20.9083"
        y2="-6.88041"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
